// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","link":"footer_link__rNuqK"};